import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";
import { Mail, MessageSquare } from "lucide-react";

export const Route = createFileRoute("/es/contact")({
  head: () => ({
    meta: [
      { title: "Contacto — Picamini.online" },
      {
        name: "description",
        content: "Ponte en contacto con el equipo de Picamini.online para sugerencias, soporte o preguntas sobre nuestras herramientas gratuitas.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/es/contacto" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/contact" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/contacto" },
    ],
  }),
  component: EsContactPage,
});

function EsContactPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="es" />

      <main className="flex-1 py-12 mx-auto max-w-2xl px-4 sm:px-6 lg:px-8 space-y-8">
        <div className="text-center space-y-3">
          <h1 className="text-3xl font-extrabold sm:text-4xl text-foreground">Contacto y Soporte</h1>
          <p className="text-base text-muted-foreground leading-relaxed">
            ¿Tienes sugerencias, ideas de nuevas herramientas o alguna consulta? Nos encantaría escucharte.
          </p>
        </div>

        <div className="surface-card p-6 sm:p-8 rounded-2xl bg-card border space-y-6 text-center">
          <div className="mx-auto size-12 grid place-items-center rounded-2xl bg-primary/10 text-primary">
            <Mail className="size-6" />
          </div>
          <div className="space-y-2">
            <h2 className="text-xl font-bold text-foreground">Correo Electrónico</h2>
            <p className="text-sm text-muted-foreground">Escríbenos directamente a:</p>
            <a
              href="mailto:support@picamini.online"
              className="inline-block text-lg font-bold text-primary hover:underline"
            >
              support@picamini.online
            </a>
          </div>
        </div>
      </main>

      <SiteFooter lang="es" />
    </div>
  );
}
